export default __webpack_public_path__ + "static/slider2-2-dab33af0540210939aa9829cebd53004.png";